import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { Uploads } from '../../services/uploads';
import { ConfigurationServices } from '../../configuration/services';
import { OrdersCoServices } from '../../orders/services';
import { TPVServices } from '../../tpv/services';
import { TakeawayServices } from '../../takeaway/services';
import { ProductsServices } from '../../products/services';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationVariationCreateListPage } from '../../configuration/configuration-variations/configuration-variations-create/configuration-variation-create-list/configuration-variation-create-list';



@Component({
  selector: 'page-variations-product-selector',
  templateUrl: 'variations-product-selector.html',
})
export class VariationsProductSelectorPage {
  name: string;
  price_selected: any = 0;
  pvp: any;
  pvp2: any;
  pvp3: any;
  type: any;
  uid: any;
  units: number = 1;
  type_selected: any = "pvp";
  section: any;
  product: any;
  sender: any;
  tags: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public uploadServices: Uploads,
    public configurationServices: ConfigurationServices,
    public tpvServices: TPVServices,
    public takeawayServices: TakeawayServices,
    public productsServices: ProductsServices) {

    this.name = this.navParams.get('name');
    this.pvp = this.navParams.get('pvp');
    this.pvp2 = this.navParams.get('pvp2');
    this.pvp3 = this.navParams.get('pvp3');
    this.type = this.navParams.get('type');
    this.uid = this.navParams.get('uid');
    this.section = this.navParams.get('section');
    this.sender = this.navParams.get('sender');//on s'envia la crida de variacions (comandero - tpv- takeaway)
    this.tags = this.navParams.get('tags');
    //check prices nan/undefined
    if (Number.isNaN(this.pvp2) || this.pvp2 == undefined) {
      this.pvp2 = 0;
    }
    if (Number.isNaN(this.pvp3) || this.pvp3 == undefined) {
      this.pvp3 = 0;
    }
    //
    this.productsServices.image_url_product_view = null;
    this.configurationServices.getVariations(this.globals.restaurant_uid);
    this.getFoodCost();
  }

  async getFoodCost() {
    if (this.type == 'product') {
      this.product = await this.productsServices.getProduct(this.uid);
      if (this.product.variations_favourite == undefined) {
        this.product.variations_favourite = [];
      }
      this.getImageUrl(this.product.image);
    }
  }

  onChange(event) {
    this.units = event.target.value;
  }

  add() {
    this.units++;
  }

  rest() {
    if (this.units > 1) {
      this.units--;
    }

  }

  checkState(type) {
    if (this.type_selected == type) {
      return true
    } else {
      return false
    }
  }

  select(type) {
    if (this.globals.checkLimitsByLicense('stock', '3prices')) {
      this.type_selected = type;
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  deleteVariation(index) {
    if (this.sender == 'comandero') {
      this.ordersCoServices.variations_tmp.splice(index, 1);
    } else if (this.sender == 'tpv') {
      this.tpvServices.variations_tmp.splice(index, 1);
    } else if (this.sender == 'takeaway') {
      this.takeawayServices.variations_tmp.splice(index, 1);
    }

  }

  //insertemamos variacion al array temporal
  insertVariation(name, price, state, type, uid) {

    var _array = {
      name: name,
      price: price,
      state: state,
      type: type,
      uid: uid,
    };

    if (this.sender == 'comandero') {
      this.ordersCoServices.variations_tmp.push(_array);
    } else if (this.sender == 'tpv') {
      this.tpvServices.variations_tmp.push(_array);
    } else if (this.sender == 'takeaway') {
      this.takeawayServices.variations_tmp.push(_array);
    }
  }

  insertToTicket() {
    if (this.type_selected == 'pvp') {
      this.price_selected = this.pvp;
    } else if (this.type_selected == 'pvp2') {
      this.price_selected = this.pvp2;
      this.name = this.name + " <b> 2.</b>";
    } else if (this.type_selected == 'pvp3') {
      this.price_selected = this.pvp3;
      this.name = this.name + " <b> 3.</b>";
    }

    if (this.sender == 'comandero') {
      this.ordersCoServices.insertTableWithVariation(this.name, this.price_selected, false, true, this.type, this.uid, this.units, this.section, { tags: this.tags });
    } else if (this.sender == 'tpv') {
      this.tpvServices.insertTableWithVariation(this.name, this.price_selected, false, true, this.type, this.uid, this.units, { tags: this.tags });
    } else if (this.sender == 'takeaway') {
      this.takeawayServices.insertTableWithVariation(this.name, this.price_selected, false, true, this.type, this.uid, this.units, this.section, { tags: this.tags });
    }


    this.navCtrl.pop();
  }

  getImageUrl(image_ref) {
    //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    this.productsServices.image_url_product_view = null;
    if (image_ref) {
      const ref = this.uploadServices.storage.ref(image_ref);
      this.productsServices.image_url_product_view = ref.getDownloadURL();
    }

  }

  back() {
    this.navCtrl.pop();
  }

  logChange(value) {
    this.units = value;
  }
  setStyle(img) {

    let styles = {
      'display': 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'background-position': 'center center',
      'background-repeat': 'no-repeat',
      'background-size': 'cover',
      'height': '300px',
      'background-image': 'url(' + img + ')',
    };
    return styles;
  }

  createVariation() {
    if (this.globals.checkLimitsByLicense('tpv', 'variations')) {
      this.navCtrl.push(ConfigurationVariationCreateListPage, {
        type: 'all'
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/variations/variations-product-selector/variations-product-selector.ts